

define(['angular', 'squid/index', 'components/xo-models/src/user/index', 'components/xo-beaver/dist/logger'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.lib.fallback', ['squid', 'beaver', 'xomodel.user']).factory('$fallbackErrorHandler', function ($FallbackError, $q, $config, $meta, $timeout, $window, $logger, $log, $rootScope, $CheckoutAppDataModel, $CheckoutInputDataModel, $ReturnToMerchant, $locale, $util, $state, $experiment) {

        function goToUrl(url, wpsParams, xoAppData) {
            if (xoAppData.doec_on_approve()) {
                return $ReturnToMerchant.postTo(url, wpsParams);
            }
            return $ReturnToMerchant.goTo(url);
        }

        return function (err) {

            function goToGenericError(reason) {
                $state.go('checkout.genericError', {
                    code: reason
                });
                return true;
            }

            /**
             * This function contains an additional determination of fallback url in case of an UX fallback
             *
             * @param {object} checkoutAppDataModel
             * @param {string} fallbackUrl
             * @returns {string}
             */
            function determineUrlForUxFallback(checkoutAppDataModel, fallbackUrl) {
                var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');

                // in case of UX fallback + PPPlus transaction -> fallback url is merchants cancel_url with added
                // parameter ppp_msg=1
                if (experienceInitiator === 'PAYPAL_PLUS') {
                    var merchantCancelUrl = checkoutAppDataModel.urls.cancel_url;
                    var ppplusParams = {
                        ppp_msg: '1'
                    };

                    fallbackUrl = $util.buildURL(merchantCancelUrl, ppplusParams);
                }

                return fallbackUrl;
            }

            var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);

            if (checkoutAppData.doec_on_approve() && $rootScope.paymentComplete) {
                // Do not fallback. UX has no context of hermes token and will result in duplicate payment
                $logger.info('wps_error_payment_already_done', {
                    reason: err.reason
                });

                return goToGenericError('PAYMENT_ALREADY_DONE');
            }

            if (err instanceof $FallbackError) {
                var reason = err.reason;
                var product = err.product;
                var entry_point = err.entryPoint;

                if ($CheckoutInputDataModel.instance($rootScope.token).requiresOAuth()) {
                    // there is no fallback for flows that require oauth code return (ex:PROX Signup),
                    // so we show a generic error page
                    $logger.log('error', 'fallback_inhibited_for_oauth_return_flows', {
                        reason: reason
                    });
                    return goToGenericError(reason);
                }

                if (product === 'ux' && $rootScope.partnerIntegration) {
                    $logger.info('partner_integration_fallback_to_UX');
                    $window.resizeTo(screen.availWidth, screen.availHeight);
                }

                // For checkout-order tokens symphony sets checkoutAppData.flags.disable_legacy_fallback flag to 'true'.
                // In such cases we disable fallback to UX and show the generic error page.
                if (checkoutAppData.flags && checkoutAppData.flags.disable_legacy_fallback) {
                    $logger.log('error', 'fallback_inhibited_for_checkout_order_tokens', {
                        reason: reason
                    });
                    return goToGenericError(reason);
                }

                $util.assert(reason, 'expected fallback reason');

                $logger.log(product ? 'info' : 'error', 'fallback', {
                    reason: reason,
                    product: product,
                    entry_point: entry_point
                });

                var country = $locale.country;
                var fallbackToUx = ($config.fallbackAriesUnsupportedToUx || []).indexOf(country) > -1;

                if (fallbackToUx) {
                    product = 'ux';
                } else {
                    product = product || 'ux';
                }

                $logger.info('fallback_reason_' + reason);

                if (checkoutAppData.doec_on_approve()) {
                    $logger.log('info', 'wps_fallback', {
                        token: $meta.token,
                        reason: reason
                    });
                    $logger.info('wps_fallback_reason_' + reason, {
                        reason: reason
                    });
                }

                if (!$config.fallbackEnabled && !entry_point) {
                    return $log.info('Fallback inhibited by config');
                }

                if ($config.deploy.isLocal() && !entry_point) {
                    return $log.info('Fallback inhibited in local mode. Please refresh to re-enable error logging');
                }

                // Fallback whitelist experiment in config to determine if we should fallback or instead redirect to generic error page.
                // We go to generic error page if the reason is not in the whitelist and random number is below the throttle value
                var fallbackWhitelist = $config.fallbackWhitelist;

                if (fallbackWhitelist && fallbackWhitelist.throttle > 0) {
                    var whitelist = fallbackWhitelist.whitelisted || [];

                    if (whitelist.indexOf(reason) === -1) {
                        if (window.sessionStorage && $experiment('fallback_reason_not_whitelisted', fallbackWhitelist.throttle, $rootScope.token, { reason: reason })) {
                            // we're using sessionStorage for retry detection
                            var RETRY_KEY = 'retry_page_shown';
                            var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
                            var timesSeen = Number(window.sessionStorage[RETRY_KEY]);
                            var destination = 'RETRY';

                            if (!timesSeen || timesSeen < 0) {
                                // Reset if there's an invalid value for timesSeen for some reason
                                timesSeen = 0;
                            }

                            if (timesSeen < RETRY_PAGE_LIMIT) {
                                // Only try to go to retry page if we're within retry attempts
                                timesSeen++;
                                window.sessionStorage[RETRY_KEY] = timesSeen;
                            } else {
                                destination = 'DEFAULT';
                            }

                            $logger.info('checkout_fpti', {
                                'enable_refresh_prompt': reason
                            });

                            return goToGenericError(destination);
                        }
                    } else {
                        $logger.info('fallback_reason_whitelisted', {
                            reason: reason,
                            product: product
                        });
                    }
                }

                $rootScope.$emit('loading');

                var urlParams = {
                    token: $meta.token,
                    fallback: 1,
                    landing: entry_point,
                    useraction: $util.param('useraction')
                };

                if ($rootScope.partnerIntegration) {
                    urlParams.incontext = '1';
                    urlParams.nolegacy = '1';
                } else if ($rootScope.miniBrowser) {
                    urlParams.incontext = '1';
                }

                var base = $config.urls.fallbackUrl[product];
                var wpsParams = void 0;

                if (checkoutAppData.doec_on_approve()) {
                    base = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow ? $config.urls.fallbackUrl['cartUpload'] : $config.urls.fallbackUrl['buyNow'];
                    wpsParams = $util.decodeAndParse($meta.xclickParams);
                }

                if (checkoutAppData.flags.is_invoice_flow) {
                    urlParams.id = checkoutAppData.invoice_id;
                    base = $config.urls.fallbackUrl['invoice'];
                }

                var url = $meta.stage ? $meta.stage : $window.location.hostname;
                url = $util.buildURL('https://' + url + base, urlParams);

                if (checkoutAppData.doec_on_approve() || checkoutAppData.flags.is_invoice_flow) {
                    goToUrl(url, wpsParams, checkoutAppData);
                    return true;
                }

                if (product === 'ux') {

                    url = determineUrlForUxFallback(checkoutAppData, url);

                    // Otherwise we can make a decision based on whether we're in the minibrowser or not

                    return checkoutAppData.action('updateFallbackAction', {
                        data: {
                            fallback_action: 'CA_FALLBACK_USER_ACTION_LOGIN_GUEST_TAB_SELECTION'
                        },
                        success: function success() {
                            $ReturnToMerchant.goTo(url);
                            return true;
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT() {
                                $ReturnToMerchant.goTo(url);
                                return true;
                            }
                        }
                    })['catch'](function () {
                        $ReturnToMerchant.goTo(url);
                        return true;
                    });
                }

                // Safe to always return to Aries
                $util.redirect(url);

                return true;
            }

            return false;
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/lib/fallback.js
// module id = ./js/lib/fallback.js
// module chunks = 1